import VueRouter from "vue-router"
import CentroCostoList from "./components/CentroCostoList.vue"
import ChangePassword from "./components/ChangePassword.vue"
import Forbidden from "./components/Forbidden.vue"
import Home from "./components/Home.vue"
import Login from "./components/Login.vue"
import MarcaList from "./components/MarcaList.vue"
import OrdenApprove from "./components/OrdenApprove.vue"
import OrdenEdit from "./components/OrdenEdit.vue"
import OrdenImportacion from "./components/OrdenImportacion.vue"
import OrdenList from "./components/OrdenList.vue"
import OrdenListApprove from "./components/OrdenListApprove.vue"
import OrdenMassive from "./components/OrdenMassive.vue"
import OrdenNew from "./components/OrdenNew.vue"
import OrdenRestart from "./components/OrdenRestart.vue"
import OrdenView from "./components/OrdenView.vue"
import PriceSearch from "./components/PriceSearch.vue"
import ProveedorList from "./components/ProveedorList.vue"
import RenovateStock from "./components/RenovateStock.vue"
import UnidadList from "./components/UnidadList.vue"
import { AppRouterConstant, ModulesEnum } from "./constants"
import AccessLayout from "./layout/AccessLayout.vue"
import AppLayout from "./layout/AppLayout.vue"
import AsignacionItems from "./modules/asignacionItems/AsignacionItems.vue"
import Caja from "./modules/caja/Caja.vue"
import RegistrarCaja from "./modules/caja/RegistrarCaja.vue"
import VerCaja from "./modules/caja/VerCaja.vue"
import Cliente from "./modules/cliente/Cliente.vue"
import Empleado from "./modules/empleado/Empleado.vue"
import Envios from "./modules/envio/Envios.vue"
import Inventario from "./modules/inventario/Inventario.vue"
import Mixers from "./modules/mixer/Mixer.vue"
import OrdenPago from "./modules/ordenPago/OrdenPago.vue"
import OrdenVenta from "./modules/ordenVenta/OrdenVenta.vue"
import PedidoItems from "./modules/pedidoItem/PedidoItems.vue"
import ProductoList from "./modules/producto/Producto.vue"
import ProductoVenta from "./modules/productoVenta/ProductoVenta.vue"
import CrearCuenta from "./modules/proveedor/CrearCuenta.vue"
import ProveedorOrdenCompra from "./modules/proveedor/ProveedorOrdenCompra.vue"
import ProyectoList from "./modules/proyecto/ProyectoList.vue"
import RendicionNew from "./modules/rendicion/RendicionNew.vue"
import TransferenciaItems from "./modules/transferenciaItems/TransferenciaItems.vue"
import Usuario from "./modules/usuario/Usuario.vue"
import Vendedor from "./modules/vendedor/Vendedor.vue"
import Environment from "./services/Environment.js"
import UsuarioService from "./services/UsuarioService.js"
import Storage from "./util/storage.js"

const noAccessMessage = "No tienes acceso a este módulo"
const activeSessionMessage = "La sesion esta activa"

const routes = [
    {
        path: "/",
        name: "",
        component: AccessLayout,
        children: [
            {
                path: "login",
                name: "Login",
                component: Login,
                meta: {
                    module: ModulesEnum.LOGIN
                }
            },

        ]
    },
    {
        path: "/",
        name: "",
        component: AppLayout,
        children: [
            {
                path: "orden",
                name: "OrdenList",
                component: OrdenList,
                meta: {
                    module: ModulesEnum.ORDEN_COMPRA
                }
            },
            {
                path: "orden/massive",
                name: "OrdenMassive",
                component: OrdenMassive,
                meta: {
                    module: ModulesEnum.ORDEN_COMPRA,
                }
            },
            {
                path: "orden/new",
                name: "OrdenNew",
                component: OrdenNew,
                meta: {
                    module: ModulesEnum.ORDEN_COMPRA,
                }
            },
            {
                path: "orden/view/:id",
                name: "OrdenView",
                component: OrdenView,
                meta: {
                    module: ModulesEnum.ORDEN_COMPRA
                }
            },
            {
                path: "orden/edit/:id",
                name: "OrdenEdit",
                component: OrdenEdit,
                meta: {
                    module: ModulesEnum.ORDEN_COMPRA
                }
            },
            {
                path: "centroCosto",
                name: "CentroCostoList",
                component: CentroCostoList,
                meta: {
                    module: ModulesEnum.CENTRO_COSTO
                }
            },
            {
                path: "unidad",
                name: "UnidadList",
                component: UnidadList,
                meta: {
                    module: ModulesEnum.UNIDAD
                }
            },
            {
                path: "marca",
                name: "MarcaList",
                component: MarcaList,
                meta: {
                    module: ModulesEnum.MARCA
                }
            },
            {
                path: "proveedor",
                name: "ProveedorList",
                component: ProveedorList,
                meta: {
                    module: ModulesEnum.PROVEEDOR
                }
            },
            {
                path: "usuario",
                name: "Usuario",
                component: Usuario,
                meta: {
                    module: ModulesEnum.USUARIO
                }
            },
            {
                path: "search",
                name: "PriceSearch",
                component: PriceSearch,
                meta: {
                    module: ModulesEnum.ORDEN_COMPRA,
                }
            },
            {
                path: "orden/approve",
                name: "OrdenListApprove",
                component: OrdenListApprove,
                meta: {
                    module: ModulesEnum.ORDEN_COMPRA,
                }
            },
            {
                path: "orden/approve/:id",
                name: "OrdenApprove",
                component: OrdenApprove,
                meta: {
                    module: ModulesEnum.ORDEN_COMPRA,
                }
            },
            {
                path: "orden/importacion/:id",
                name: "OrdenImportacion",
                component: OrdenImportacion,
                meta: {
                    module: ModulesEnum.ORDEN_COMPRA,
                }
            },
            {
                path: "orden/restart/:id",
                name: "OrdenRestart",
                component: OrdenRestart,
                meta: {
                    module: ModulesEnum.ORDEN_COMPRA,
                }
            },
            {
                path: "renovate",
                name: "RenovateStock",
                component: RenovateStock,
                meta: {
                    module: ModulesEnum.ORDEN_COMPRA,
                }
            },
            {
                path: "user/change-password",
                name: "ChangePassword",
                component: ChangePassword,
                meta: {
                    module: ModulesEnum.CHANGE_PASSWORD,
                }
            },
            {
                path: "producto",
                name: "ProductoList",
                component: ProductoList,
                meta: {
                    module: ModulesEnum.PRODUCTO
                }
            },
            {
                path: "caja",
                name: "Caja",
                component: Caja,
                meta: {
                    module: ModulesEnum.CAJA
                }
            },
            {
                path: "caja/new",
                name: "RegistrarCaja",
                component: RegistrarCaja,
                meta: {
                    module: ModulesEnum.CAJA,
                }
            },
            {
                path: "caja/view/:id",
                name: "VerCaja",
                component: VerCaja,
                meta: {
                    module: ModulesEnum.CAJA,
                }
            },
            {
                path: "caja/edit/:id",
                name: "ModificarCaja",
                component: RegistrarCaja,
                meta: {
                    module: ModulesEnum.CAJA,
                }
            },
            {
                path: "rendicion/new/:id/:codigo",
                name: "RendicionNew",
                component: RendicionNew,
                meta: {
                    module: ModulesEnum.CAJA,
                }
            },
            {
                path: "ordenPago/:ord_id",
                name: "ordenPago",
                component: OrdenPago,
                meta: {
                    module: ModulesEnum.ORDEN_PAGO,
                }
            },
            {
                path: "ordenPago/:ord_id/:interfaz/:opg_id",
                name: "verOrdenPago",
                component: OrdenPago,
                meta: {
                    module: ModulesEnum.ORDEN_PAGO,
                }
            },
            {
                path: "proyecto",
                name: "ProyectoList",
                component: ProyectoList,
                meta: {
                    module: ModulesEnum.PROYECTO,
                }
            },
            {
                path: "empleado",
                name: "Empleado",
                component: Empleado,
                meta: {
                    module: ModulesEnum.EMPLEEADO,
                }
            },
            {
                path: "asignaciones",
                name: "AsignacionItems",
                component: AsignacionItems,
                meta: {
                    module: ModulesEnum.ASIGNACION_ITEMS,
                }
            },
            {
                path: "transferencia",
                name: "TransferenciaItemsList",
                component: TransferenciaItems,
                meta: {
                    module: ModulesEnum.TRANSFERENCIA_ITEMS,
                }
            },
            {
                path: "inventario",
                name: "Inventario",
                component: Inventario,
                meta: {
                    module: ModulesEnum.INVENTARIO,
                }
            },
            {
                path: "cliente",
                name: "cliente",
                component: Cliente,
                meta: {
                    module: ModulesEnum.CLIENTE,
                }
            },
            {
                path: "productoVenta",
                name: "productoVenta",
                component: ProductoVenta,
                meta: {
                    module: ModulesEnum.PRODUCTO_VENTA,
                }
            },
            {
                path: "ordenVenta",
                name: "ordenVenta",
                component: OrdenVenta,
                meta: {
                    module: ModulesEnum.ORDEN_VENTA,
                }
            },
            {
                path: "envios",
                name: "envios",
                component: Envios,
                meta: {
                    module: ModulesEnum.ENVIO,
                }
            },
            {
                path: "mixers",
                name: "mixers",
                component: Mixers,
                meta: {
                    module: ModulesEnum.MIXER,
                }
            },
            {
                path: "vendedor",
                name: "vendedor",
                component: Vendedor,
                meta: {
                    module: ModulesEnum.VENDEDOR,
                }
            },
            {
                path: "pedidoItems",
                name: "pedidoItems",
                component: PedidoItems,
                meta: {
                    module: ModulesEnum.PEDIDO_ITEMS,
                }
            },
            {
                path: "pedidoItems/:action/:id",
                name: "verPedidoItems",
                component: PedidoItems,
                meta: {
                    module: ModulesEnum.PEDIDO_ITEMS,
                }
            },
            {
                path: "proveedor/crearCuenta",
                name: "CrearCuenta",
                component: CrearCuenta,
                meta: {
                    module: ModulesEnum.CREAR_CUENTA,
                }
            },
            {
                path: "proveedor/ordenCompra",
                name: "ProveedorOrdenCompra",
                component: ProveedorOrdenCompra,
                meta: {
                    module: ModulesEnum.PROVEEDOR_ORDEN_COMPRA,
                }
            },
            {
                path: "home",
                name: "Home",
                component: Home,
                meta: {
                    module: ModulesEnum.HOME,
                }
            },
            {
                path: "forbidden",
                name: "Forbidden",
                component: Forbidden
            },
            // {
            //     path: "",
            //     redirect: "/home"
            // },
            // {
            //     path: "*",
            //     redirect: "/home"
            // },
        ]
    },


]

const AppRouter = new VueRouter({
    mode: "history",
    routes
})

const activeSession = () => {
    return UsuarioService.getUsuario() != null
}

const verifyModuleAcces = (_toName, _module) => {
    if (_toName == "Home" || _toName == "ChangePassword") return true
    // este metodo permite verificar a que módulos tiene acceso el usuario
    let modules = []
    UsuarioService
        .getUsuario()
        .modulo_grupos
        .forEach(modulo_grupo => {
            modulo_grupo.modulos.forEach(modulo => {
                modules.push(modulo.mod_codigo)
            })
        })
    return modules.some(module => module === _module)
}

const goLogin = () => {
    AppRouter.push({
        name: "Login",
    })
}

const goHome = () => {
    AppRouter.push({
        name: "Home",
    })
}

const savePendingRoute = (_toPath, _toName, _toModule) => {
    if (_toName != "Login" && _toName != "") {
        // eliminado alguna ruta pendiente previa
        Storage.remove(AppRouterConstant.PENDING_ROUTE)
        // guardando la nueva ruta pendiente
        Storage.setObject(AppRouterConstant.PENDING_ROUTE, { path: _toPath, module: _toModule })
    }
}

const saveAppVersion = () => {
    Storage.setValue(AppRouterConstant.APP_VERSION, Environment.version)
}

AppRouter.beforeEach((to, from, next) => {
    // obteniendo los datos necesarios para el control de enrutamiento
    const { path: _toPath, meta: _toMeta, name: _toName } = to
    const { module: _toModule } = _toMeta
    const { path: _fromPath, meta: _fromMeta, name: _fromName } = from
    const { module: _fromModule } = _fromMeta
    const appVersion = Storage.getValue(AppRouterConstant.APP_VERSION)
    // si no hay versión registrada, el sistema lo registra por primera vez
    if (!appVersion) saveAppVersion()
    // si hay versión registrada pero es diferente a la versión publicada, dicha versión se actualiza
    if (appVersion != Environment.version) {
        // borrando los datos de localstorage para forzar el inicio de una nueva sesion
        Storage.removeAll()
        saveAppVersion()
        savePendingRoute(_toPath, _toName, _toModule)
    }
    // revisando si el usuario solicita ir a Login
    if (_toName == "Login") {
        if (activeSession()) {
            // si existe una sesion activa, esta será eliminada
            UsuarioService.logout()
            next()
            return
        }
        else {
            // enruta a Login
            next()
            return
        }
    }
    // verificando si existe una sesion activa para redireccionar a la ruta solicitada o al Login
    if (!activeSession()) {
        savePendingRoute(_toPath, _toName, _toModule)
        goLogin()
        return
    }
    // revisando si existe alguna ruta pendiente
    if (Storage.getObject(AppRouterConstant.PENDING_ROUTE) != null) {
        // obteniendo la ruta pendiente
        const pendingRoute = Storage.getObject(AppRouterConstant.PENDING_ROUTE)
        // eliminando la ruta pendiente
        Storage.remove(AppRouterConstant.PENDING_ROUTE)
        // enrutando a la ruta pendiente
        AppRouter.push({
            path: pendingRoute.path,
        })
        return
    }
    // revisando a que modulos tiene acceso el usuario
    if (verifyModuleAcces(_toName, _toModule)) {
        next()
    }
    else {
        alert("No tiene acceso a ruta o módulo")
        goHome()
    }
})

export default AppRouter